module.exports = __webpack_public_path__ + "img/sprinkle-22.8d752e8e.jpg";